import { h, defineComponent } from 'vue';
import { Field, FieldProps } from '@/ui/components/form/Field';

export interface ReadOnlyFieldProps {
  name: string;
  label: string;
  value: string;
  icon?: string;
  hideLabel?: boolean;
  horizontal?: boolean;
}

export const ReadOnlyField = defineComponent<ReadOnlyFieldProps>({
  name: 'ReadyOnlyField',
  props: ['name', 'label', 'value', 'icon', 'hideLabel', 'horizontal'],
  setup(props) {
    return function render() {
      const fieldProps: FieldProps = {
        ...props,
        required: false,
        errors: [],
      };

      return h(Field, { props: fieldProps }, [
        h('span', [props.value]),
      ]);
    };
  },
});

export function readOnlyField(props: ReadOnlyFieldProps) {
  return h(ReadOnlyField, { props });
}
